import { render, staticRenderFns } from "./flatsSetting.vue?vue&type=template&id=a181744a&"
import script from "./flatsSetting.vue?vue&type=script&lang=js&"
export * from "./flatsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports